import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Buttom from '../../components/Button/Button';
import CustomDropdown from '../../components/CustomDropdown/CustomDropdown';
import Header from '../../components/Header/Header';
import { SettingsContext } from '../../contexts/SettingsContext';
import { cameras } from '../../utils/constants';
import './SettingsPage.css';

function SettingsPage({isLoggedIn}) {
  const {selectedCameras, setSelectedCameras, selectedImageSize, setSelectedImageSize, selectedQuality, setSelectedQuality} =
    useContext(SettingsContext);

  const [localSelectedCameras, setLocalSelectedCameras] = useState(selectedCameras);
  const [localImageSize, setLocalImageSize] = useState(selectedImageSize);
  const [localQuality, setLocalQuality] = useState(selectedQuality);
  const [isEditing, setIsEditing] = useState(false);

  /* fix: нужны глобальные настройки */

  const navigate = useNavigate();

  /*  const imageSizeOptions = [512, 1024, 2048];
  const qualityOptions = [0.1, 0.3, 0.5, 0.7, 1.0]; */

  const imageSizeOptions = [512, 1024, 2048].map((size) => ({label: size.toString(), value: size}));
  const qualityOptions = [0.1, 0.3, 0.5, 0.7, 1.0].map((q) => ({label: q.toString(), value: q}));

  useEffect(() => {
    setLocalSelectedCameras(selectedCameras);
    setLocalImageSize(selectedImageSize);
    setLocalQuality(selectedQuality);
  }, [selectedCameras, selectedImageSize, selectedQuality]);

  const handleCameraChange = (e) => {
    const {name, checked} = e.target;
    setLocalSelectedCameras((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleImageSizeChange = (e) => {
    setLocalImageSize(Number(e.target.value));
  };

  const handleQualityChange = (e) => {
    setLocalQuality(Number(e.target.value));
  };

  const handleEditSave = () => {
    if (isEditing) {
      setSelectedCameras(localSelectedCameras);
      setSelectedImageSize(localImageSize);
      setSelectedQuality(localQuality);
      toast.success('Настройки сохранены');
    }
    setIsEditing(!isEditing);
  };

  return (
    <div className='settings-page'>
      <Header isLoggedIn={isLoggedIn} />
      <div className='settings-wrapper'>
        {/* <h1>НАСТРОЙКИ</h1> */}

        <div className='settings-container'>
          <section className='camera-settings'>
            <h2>Камеры</h2>
            <div className='camera-list'>
              {cameras.map((camera) => (
                <div key={camera.id} className='camera-item'>
                  <label>
                    <input
                      type='checkbox'
                      name={camera.id}
                      checked={localSelectedCameras[camera.id]}
                      onChange={handleCameraChange}
                      disabled={!isEditing}
                    />
                    {camera.name}
                  </label>
                </div>
              ))}
            </div>
          </section>

          <section className='parameter-settings'>
            <h2>Параметры</h2>
            <div className='select-group'>
              <label htmlFor='image-size-select'>Размер фото</label>
              <CustomDropdown
                options={imageSizeOptions}
                selectedValue={localImageSize}
                onChange={(val) => setLocalImageSize(val)}
                type='settings'
              />
            </div>
            <div className='select-group'>
              <label htmlFor='quality-select'>Качество фото</label>
              <CustomDropdown
                options={qualityOptions}
                selectedValue={localQuality}
                onChange={(val) => setLocalQuality(val)}
                type='settings'
              />
            </div>
          </section>
        </div>
        <div className='settings-page__button-container'>
          <Buttom
            buttonId='settings-button__save'
            buttonName={'Назад к камерам'}
            additionalClass={'button__edit'}
            onClick={() => navigate('/')}
          />

          <Buttom
            buttonId='settings-button__save'
            buttonName={isEditing ? 'Сохранить' : 'Изменить'}
            additionalClass={isEditing ? 'button__save' : 'button__edit'}
            onClick={handleEditSave}
          />
        </div>
      </div>
    </div>
  );
}

export default SettingsPage;
